// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2qov9","ranges":"BmiRanges_ranges__1bwGI"};